import React, { useEffect, useState } from 'react';
import styles from './category-box.module.scss';
import gridStyles from './grid-components.module.scss';
import { Input } from 'antd';
import {
  RenderCategoryIcon,
  RenderContentType,
  RenderTags,
  RenderMetadata,
  RenderLabels,
  RenderIndicationRibbon,
} from '../components';
import { CATEGORY_TYPES } from 'shared/constants';
const { TextArea } = Input;

export function CategoryBoxComponent({
  title = '',
  type,
  tags,
  labels,
  metadata,
  options,
  lastUpdatedAt,
  categoryType,
  adminMode,
  onBlur,
  onClick,
  actions,
  badge,
  hasEditPermission,
}) {
  const isCategory = type === CATEGORY_TYPES.CATEGORY;
  const isTitleEditable = adminMode && hasEditPermission;
  const [titleInput, setTitleInput] = useState(title);
  const showUpdatedIndication = !adminMode && lastUpdatedAt;

  useEffect(() => {
    if (titleInput !== title) {
      setTitleInput(title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  const onInputFocus = e => {
    if (!isTitleEditable) return;
    e.stopPropagation();
  };

  const onHeaderPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    }
  };

  const onChange = e => {
    const { value } = e.target;
    setTitleInput(value);
  };

  return (
    <button className={styles.root} onClick={onClick} aria-label={title}>
      <div className={styles.iconWrapper}>
        <RenderCategoryIcon
          title={title}
          type={type}
          isCategory={isCategory}
          categoryType={categoryType}
          adminMode={adminMode}
          options={options}
          styles={gridStyles}
        />
        {showUpdatedIndication && <RenderIndicationRibbon lastUpdate={lastUpdatedAt} />}
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.titleWrapper}>
            <TextArea
              onClick={onInputFocus}
              onKeyPress={onHeaderPress}
              onBlur={onBlur}
              className={styles.text}
              autoSize={{ minRows: 1, maxRows: 1 }}
              // `readOnly`, not `disabled` — a disabled control fires no click event, so
              // the click never bubbles to the card and the category wouldn't open.
              // Keep the non-editable title out of the tab order; the card button
              // is the keyboard target.
              readOnly={!isTitleEditable}
              tabIndex={isTitleEditable ? undefined : -1}
              onChange={onChange}
              value={titleInput}
            />
            {badge}
          </div>
          <div className={styles.actions}>{actions}</div>
        </div>
        <div className={styles.tags}>
          <RenderTags tags={tags} styles={gridStyles} />

          <RenderLabels labels={labels} styles={gridStyles} />
        </div>
        <div className={styles.metadata}>
          <RenderMetadata
            metadata={metadata}
            adminMode={adminMode}
            isCategory={isCategory}
            categoryType={categoryType}
            options={options}
            styles={gridStyles}
          />
          <RenderContentType tags={tags} styles={gridStyles} />
        </div>
      </div>
    </button>
  );
}
